// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SaudiArabiaForm_wrapper__CGyVb","fullRow":"SaudiArabiaForm_fullRow__iPc76","row":"SaudiArabiaForm_row__PO_n2"};